/* eslint-disable react-native/no-color-literals */
import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  borderContainer: {
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderColor: "#d9d9d9",
    borderRadius: 10,
  },

  tierContentContainer: {
    borderRadius: 10,
    padding: 10,
    width: "100%", // Take full width of parent by default
    maxWidth: 500, // But don’t exceed 500 pixels
    alignSelf: "center",
  },

  button: { marginBottom: 20 },
  container: { height: "100%", padding: 10 },
  text: { fontFamily: typography.primary.normal, marginTop: 10, alignSelf: "flex-end" },
  textContainer: { alignSelf: "flex-start", fontSize: 12, marginBottom: 5 },
  tierTitle: { fontFamily: typography.primary.normal, fontSize: 28 },
  tierBoxFlex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 15,
  },
  image: {
    height: "100%",
    width: "100%",
    resizeMode: "contain",
  },
  tierBoxRight: {
    width: "70%",
    height: "100%",
  },
  TierTitleContainer: {
    display: "flex",
    width: "100%",
  },
  benefitText: {
    fontFamily: typography.primary.normal,
    alignItems: "flex-start",
  },
  benefitDesc: {
    fontFamily: typography.primary.normal,
    alignItems: "flex-start",
    fontSize: 10,
    width: "55%",
  },
  pointImage: {
    width: 30,
    height: 30,
    resizeMode: "contain",
    marginRight: 15,
  },
  voucherImage: {
    alignSelf: "center",
    borderRadius: 10,
  },
  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    marginTop: 3,
  },
  showAllText: {
    fontFamily: typography.primary.normal,
    fontSize: 14,
  },
})
